import React from 'react';
import Modal from 'react-bootstrap-modal';
import TextInput from '../controls/textInput.jsx';
import InfoModal from './infoModal.jsx'
import { apiPost } from '../services/apiClient';

export default class RestorePasswordModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
			isBusy: false,
			title: "Восстановление пароля",
            email: "",
            error: null,
            promiseResolve: null,
            promiseReject: null
        };

		this.infoModal = null;
    }

    open() {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
				isBusy: false,
                email: "",
                error: null,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }

    close(result) {
        if (result) {
            this.state.promiseResolve();
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
			isBusy: false,
            promiseResolve: null,
            promiseReject: null
        });
    }

	send() {
		let data = {
            email: this.state.email
		};
        this.setState({
            isBusy: true,
            error: null
        });
		apiPost('auth/restore', data)
			.then(() => {
				this.close(true);
				if (this.infoModal) {
					this.infoModal.open(this.state.title, "Вам отправлено электронное письмо с новым паролем на указанный адрес");
				}
			})
            .catch(error => {
				this.setState({ 
					isBusy: false,
                    error: error
				});
			});
	}

    render() {
        let errorMessage = null;
        let formGroupClasses = "form-group has-feedback";
        if (this.state.error) {
            errorMessage = (
                <span className="help-block">{this.state.error}</span>
            );
            formGroupClasses = formGroupClasses + " has-error";
        }

        return (
			<div>
				<Modal show={this.state.isOpen} 
					onHide={() => this.close(false)} 
					aria-labelledby="ModalHeader" 
					backdrop="static"
				>
					<Modal.Header closeButton>
						<Modal.Title id='ModalHeader'>
							{this.state.title}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
                        <div className={formGroupClasses}>
							<label htmlFor="modalEmail">Адрес электронной почты<span className="text-red">*</span></label>
							<TextInput id="modalEmail"
								type="email"
								value={this.state.email}
								onChange={value => this.setState({ email: value })}
								disabled={this.state.isBusy}
                            />
                            {errorMessage}
						</div>
					</Modal.Body>
					<Modal.Footer>
                        <button className='btn btn-primary' onClick={() => this.send()} disabled={this.state.isBusy}>
							Восстановить
						</button>
                        <Modal.Dismiss className='btn btn-default' disabled={this.state.isBusy}>
							Отмена
						</Modal.Dismiss>
					</Modal.Footer>
				</Modal>

				<InfoModal ref={modal => this.infoModal = modal} />
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/restorePasswordModal.jsx